import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateContactLegacyId as UpdateContactLegacyIdMutation,
    UpdateContactLegacyIdVariables,
} from 'nutshell-graphql-types';

import UPDATE_CONTACT_LEGACY_ID from '../mutations/update-contact-legacy-id.graphql';

export function useUpdateContactLegacyId(): {
    updateContactLegacyId: (contactId: string, legacyId: string | null) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateContactLegacyId, {loading, error}] = useMutation<
        UpdateContactLegacyIdMutation,
        UpdateContactLegacyIdVariables
    >(UPDATE_CONTACT_LEGACY_ID);

    return {
        updateContactLegacyId: (contactId: string, legacyId: string | null) =>
            updateContactLegacyId({
                variables: {input: {contact: {id: contactId, legacyId}}},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
